import React, { useCallback, useEffect, useState } from "react";
import Switch from "../../../../../../../components/Inputs/Switch/Switch";
import styles from '../styles.module.scss';
import { Box } from "@material-ui/core";
import Button from "../../../../../../../components/Buttons/Button";
import Dropdown from "../../../../../../../components/Inputs/Dropdown";
import OutlineButton from "../../../../../../../components/OutlineButton/OutlineButton";
import TextInput from "../../../../../../../components/Inputs/TextInput";
import Radio from '../../../../../../../components/Inputs/Radio/Radio';
import FlexRow from "../../../../../../../components/FlexBox/FlexRow";
import SButton from "../../../../../../../components/SButton/SButton";
import Typography from "../../../../../../../components/Typography/Typography";
import FlexColumn from "../../../../../../../components/FlexBox/FlexColumn";

//MODE = 0 (Add), 1 (Edit)
const DoorSettings = ({ hBack, hSave, accessPointDetails, backStep, mode = 0, hUpdate, inProgress = false }) => {
    const [lockingMech, setLockingMech] = useState({
        name: '',
        value: '',
        relayTime: '',
    });
    const [relayTime, setRelayTime] = useState(0);
    const [inveteredRelayLogic, setInveteredRelayLogic] = useState(false);
    const [attendanceEnabled, setAttendanceEnabled] = useState(false);
    const [relayTimeError, setRelayTimeError] = useState('');
    const [toggleRelaytime, setToggleRelayTime] = useState(true);
    const [doorSensorEnabled, setDoorSensorEnabled] = useState(false);
    const [normallyOpen, setNormallyOpen] = useState(true);

    useEffect(() => {
        if (mode === 1) {
            const toSend = {
                lockingMech,
                relayTime,
                inveteredRelayLogic,
                attendanceEnabled,
                doorSensorSettings: {
                    doorSensorEnable: doorSensorEnabled,
                    doorSensorType: normallyOpen ? 1 : 2
                }
            }
            hUpdate && hUpdate(toSend);
        }
    }, [lockingMech, relayTime, inveteredRelayLogic, attendanceEnabled, doorSensorEnabled, normallyOpen, hUpdate, mode])

    useEffect(() => {
        if (mode === 1) {
            if (accessPointDetails?.lockingMech) {
                setLockingMech(accessPointDetails?.lockingMech)
            }
            if (accessPointDetails?.relayTime) {
                setRelayTime(accessPointDetails?.relayTime)
            }
            if (accessPointDetails?.inveteredRelayLogic) {
                setInveteredRelayLogic(accessPointDetails?.inveteredRelayLogic)
            }
            if (accessPointDetails?.attendanceEnabled) {
                setAttendanceEnabled(accessPointDetails?.attendanceEnabled)
            }
            setDoorSensorEnabled(accessPointDetails?.doorSensorSettings?.doorSensorEnable);
            setNormallyOpen(accessPointDetails?.doorSensorSettings?.doorSensorType === 1)

        }
    }, [accessPointDetails, mode])

    const setRelayValue = useCallback((value) => {
        if (value <= 240) {
            setRelayTime(value);
        }
    }, []);

    const handleSave = () => {
        const toSend = {
            lockingMech,
            relayTime,
            inveteredRelayLogic,
            attendanceEnabled,
            doorSensorEnabled,
            normallyOpen,
        }
        hSave && hSave(toSend);
    }

    const selectLockingMechanism = useCallback((data) => {
        setRelayTime(data?.relayTime ? data?.relayTime : 0);
        setLockingMech({ name: data.name, value: data.value });
    }, []);

    const renderRelayTime = useCallback(() => {
        return (
            <div className={styles.relay_container}>
                <div className={styles.header}>
                    <h1 className={styles.header__title}>
                        {accessPointDetails?.configuration?.value === 6 ? 'Door Settings' : 'Relay Settings'}
                    </h1>
                    {accessPointDetails?.configuration?.value !== 6 ? (
                        <>
                            {lockingMech?.name === '' && accessPointDetails?.configuration?.formOptions?.relayTime ? (
                                <p className={styles.access_alert}>No locking mechanism selected</p>
                            ) : (
                                <>
                                    {accessPointDetails?.configuration?.formOptions?.relayTime ? (
                                        <SButton
                                            variant={"secondary"}
                                            color={"brand"}
                                            onClick={(e) => {
                                                setToggleRelayTime(!toggleRelaytime);
                                            }}
                                        >Hide Details</SButton>
                                    ) : (
                                        <p className={styles.access_alert}>No settings available</p>
                                    )}
                                </>
                            )}
                        </>
                    ) : (
                        <SButton
                            variant={"secondary"}
                            color={"brand"}
                            onClick={(e) => {
                                setToggleRelayTime(!toggleRelaytime);
                            }}
                        >Hide Details</SButton>
                    )}
                </div>

                {toggleRelaytime && (lockingMech?.name !== '' || accessPointDetails?.configuration?.value === 6) && (
                    <div className={styles.relay_container__body}>
                        <br />
                        <FlexRow gap="0.5rem" justifyContent="start">
                            <Typography variant={"b2R"}>{accessPointDetails?.configuration.value === 6 ? 'Door open duration' : 'Relay on Time'}</Typography>
                            <FlexColumn width="fit-content" alignItems="start" justifyContent="space-between">
                                <FlexColumn width="3.4rem">
                                    <TextInput
                                        name=""
                                        value={relayTime}
                                        type={'number'}
                                        min="1"
                                        max="240"
                                        onChange={(e) => {
                                            if (e.target.value <= 0) {
                                                setRelayTimeError('Relay time cannot be set to 0');
                                            } else {
                                                setRelayTimeError('');
                                            }
                                            setRelayValue(e.target.value);
                                        }}
                                        style={{ width: '5rem' }}
                                    />
                                </FlexColumn>
                                <Typography variant={"b4R"} color="var(--info-500)">Allowed range is 1-240 seconds.</Typography>
                            </FlexColumn>
                        </FlexRow>

                        {relayTimeError !== '' ? (
                            <FlexRow justifyContent="start" styles={{ margin: '1rem 0' }}>
                                <Typography variant="b3R" style={{ color: 'red', textAlign: 'right' }}>
                                    {relayTimeError}
                                </Typography>
                            </FlexRow>
                        ) : (
                            <></>
                        )}
                        {accessPointDetails?.configuration?.value !== 6 && (
                            <>
                                <div className={styles.row}>
                                    <div className={styles.column}>
                                        <p>Invert relay logic</p>
                                    </div>
                                    <div className={styles.column}>
                                        <Switch
                                            checked={inveteredRelayLogic}
                                            onChange={() => setInveteredRelayLogic(!inveteredRelayLogic)}
                                        />
                                    </div>
                                </div>
                                <p className={styles.access_alert}>
                                    Enabling this changes the logic of the relay and you will have to wire fail-safe
                                    locks to NO and fail-secure to NC. This will unlock the doors if the Spintly
                                    reader/controller fails.
                                </p>
                            </>
                        )}
                    </div>
                )}
            </div>
        );
    }, [
        toggleRelaytime,
        relayTime,
        inveteredRelayLogic,
        accessPointDetails?.configuration,
        lockingMech,
        setRelayValue,
        relayTimeError,
    ]);

    return (<>
        <FlexColumn alignItems="start" gap="0" styles={{ marginBottom: '3.5rem' }}>
            {accessPointDetails?.configuration?.formOptions?.lockingMechanism && (
                <div className={styles['dropdown-container']}>
                    <Dropdown
                        placeholder="Locking Mechanism"
                        value={lockingMech?.name}
                        onChange={selectLockingMechanism}
                        data={accessPointDetails?.configuration?.lockingMech ? Object?.values(accessPointDetails?.configuration?.lockingMech) : []}
                    />
                </div>
            )}
            {renderRelayTime()}

            {accessPointDetails?.configuration?.formOptions?.attendanceAvailable && (
                <>
                    <div className={styles.border} />
                    <div className={styles.row}>
                        <div className={styles.column}>
                            <p className={styles.enabledText}>Enable Attendance for device</p>
                        </div>
                        <div className={styles.column}>
                            <Switch
                                checked={attendanceEnabled}
                                onChange={() => setAttendanceEnabled(!attendanceEnabled)}
                            />
                        </div>
                    </div>
                </>
            )}

            {accessPointDetails?.configuration?.formOptions?.doorSensor && !['102C', '1027', '1025', '103D', '102F'].includes((accessPointDetails?.entryDeviceSerialNum?.value || accessPointDetails?.exiteDeviceSerialNum?.value)?.substring(0, 4)) && //Device Should not be 2DC, 1DC and FR
                (
                    <>
                        <div className={styles.row}>
                            <div className={styles.column}>
                                <p className={styles.enabledText}>Enable Door Sensors</p>
                            </div>
                            <div className={styles.column}>
                                <Switch
                                    checked={doorSensorEnabled}
                                    onChange={() => setDoorSensorEnabled(!doorSensorEnabled)}
                                />
                            </div>
                        </div>


                        {doorSensorEnabled && <div className={styles.door_sensor}>
                            <h1 className={styles.title}>
                                Door Sensor Configuration
                            </h1>
                            <div className={styles.outer_container}>
                                <div className={styles.inner_container}>
                                    <Radio
                                        color="primary"
                                        value="NO"
                                        checked={normallyOpen}
                                        onChange={() => { setNormallyOpen(true) }}
                                    />
                                    <p>Normally Open (N.O.)</p>
                                </div>

                                <div className={styles.inner_container}>
                                    <Radio
                                        color="primary"
                                        value="NC"
                                        checked={!normallyOpen}
                                        onChange={() => { setNormallyOpen(false) }}
                                    />
                                    <p>Normally Closed (N.C.)</p>
                                </div>
                            </div>
                            <p className={styles.note}>Note : Door sensor should be connected to {(accessPointDetails?.configuration?.value === 3 || accessPointDetails?.configuration?.value === 4) ? "controller" : accessPointDetails?.configuration?.value === 7 ? "exit reader" : "entry reader"}</p>
                        </div>}
                    </>
                )}
        </FlexColumn>

        {mode === 0 && <FlexRow styles={{ marginTop: '1rem' }} justifyContent="end" className={styles["fixed-actions"]}>
            <SButton disabled={inProgress} color={"grey"} minWidth onClick={() => { hBack && hBack(backStep) }}>Back</SButton>
            <SButton
                disabled={inProgress || ((!['2', '5']?.includes(accessPointDetails?.controllerType) && accessPointDetails?.configuration?.value !== 5) ? accessPointDetails?.configuration?.value === 6 ? relayTime <= 0 : (!lockingMech?.value || relayTimeError?.length > 0) : false)}
                minWidth
                onClick={handleSave}>Next</SButton>
        </FlexRow>}
    </>)
};

export default DoorSettings;